import React from 'react';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { VIEWS, VIEW_TABS_VISIBLE } from '../utils/viewConfig';

/**
 * Tab bar for switching between product views (List, Gap Analysis, etc.).
 * Props:
 *   activeView  - currently selected tab value
 *   onChange    - Tabs onChange handler (event, value)
 *   actions     - optional node rendered on the right side of the tab row (e.g. Columns picker)
 */
const ViewTabs = ({ activeView, onChange, actions }) => {
    if (!VIEW_TABS_VISIBLE && !actions) return null;

    return (
        <Stack>
            <Stack
                direction="row"
                alignItems="center"
                px={2}
                py={0.75}
                justifyContent={VIEW_TABS_VISIBLE ? undefined : 'flex-end'}
            >
                {VIEW_TABS_VISIBLE && (
                    <Tabs value={activeView} onChange={onChange} sx={{ flexGrow: 1, minHeight: 0 }}>
                        {VIEWS.map(({ value, label }) => (
                            <Tab key={value} value={value} label={label} />
                        ))}
                    </Tabs>
                )}
                {actions}
            </Stack>
            <Divider />
        </Stack>
    );
};

export default ViewTabs;
